import React from 'react';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { PageLayout } from '@/components/PageLayout';
import { AppSidebar } from '@/components/layout/AppSidebar';
import { AppTopBar } from '@/components/layout/AppTopBar';
import { PageTopBarProvider } from '@/components/layout/PageTopBarContext';

/**
 * Shell for authenticated routes that do not require an active team
 * (link-shopify, OAuth callbacks). Includes searchable sidebar and the
 * sticky top bar with breadcrumbs and store switcher.
 */
export function AuthenticatedLayout({ children }: { children: React.ReactNode }) {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <PageTopBarProvider>
          <AppTopBar />
          <PageLayout>{children}</PageLayout>
        </PageTopBarProvider>
      </SidebarInset>
    </SidebarProvider>
  );
}
